import { connectRouter } from 'connected-react-router'
import accountSlide from './accountSlice'
import commonSlice from './commonSlice'

export const rootReducer = (history) => ({
  router: connectRouter(history),
  account: accountSlide,
  common: commonSlice,
})
